import React from "react";
import "./support.scss";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import { Accordion } from "react-bootstrap";

const Gettingstarted = () => {
  return (
    <>
      <div className="maincontent">
        <div className="innercontent">
          <div>
            <h1 className="mainhead">Getting Started</h1>
            <p className="mainpara">
              Welcome to the tomi app, your gateway to a new era of digital
              interaction, combining social networking with secure
              cryptocurrency transactions. This section provides an overview of
              essential topics for first-time users.{" "}
            </p>
            <p className="mainpara">
              To get started, download and install the app from Google Play or
              Apple App Store. Then click on the links below to get step-by-step
              instructions on the selected topic.
            </p>
            <Accordion defaultActiveKey="0">
              <Element name="createanewtomiaccount">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Create a new tomi account</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      If you are new to the tomi app, follow the steps below to
                      create a new tomi account. If you already have an account,
                      learn how to{" "}
                      <Link
                        to="importanexistingaccount"
                        className="hoverlink"
                        spy={true}
                        smooth={true}
                        duration={300}
                      >
                        import your existing account.
                      </Link>
                    </p>
                    <ol>
                      <li>
                        On the app’s opening screen, tap{" "}
                        <strong>Create a new tomi account</strong>.{" "}
                      </li>
                      <li>
                        On the Claim your free username screen, tap{" "}
                        <strong>Claim username</strong>. You can also skip this
                        step and claim a username later, if you prefer.
                      </li>
                      <li>
                        Enter the name you’d like to use in the app. This
                        display name will be shown to other app users in the
                        chat, when sending funds, and in any other action you
                        perform in the app. Important: The username can’t be
                        changed later, so be sure to choose the right one for
                        you.
                      </li>
                      <li>
                        Slide right on the slider bar at the bottom to claim
                        your username.
                      </li>
                      <li>
                        If the username you entered is available, a confirmation
                        message will appear. If the username is already taken,
                        try choosing a different name.
                      </li>
                      <li>
                        Tap <strong>Continue</strong>.
                      </li>
                      <li>
                        Choose one of the avatars for your profile photo, or tap
                        the plus (+) button to take a photo or upload an image
                        from your device’s gallery. When you’re ready, tap Done.
                      </li>
                      <li>
                        Enter a 6-digit code that will serve as an extra layer
                        of security when using the app, then enter it again to
                        confirm it. You can also choose to enable biometric
                        authentication for the sign in.
                      </li>
                      <li>
                        Your account has now been created and you can start
                        using the app.
                      </li>
                    </ol>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="backupyourseedphrase">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Backup your seed phrase</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      Backing up your seed phrase is essential for securing your
                      account and recovering it if needed. To back up your seed
                      phrase, follow these steps:
                    </p>
                    <ol>
                      <li>
                        On the <strong>Profile</strong> screen, tap{" "}
                        <strong>Backup Your Account</strong>.
                      </li>
                      <li>
                        A message will appear explaining that this is your
                        secret recovery phrase. Tap <strong>View Phrase</strong>{" "}
                        to reveal it.
                      </li>
                      <li>
                        Write down all 12 words in the exact order displayed on
                        the screen. Store this information in a secure location.
                        Do not share it with anyone.
                      </li>
                      <li>
                        Tap <strong>Continue</strong>, and you’ll be prompted to
                        verify your seed phrase by selecting the words in the
                        correct order.
                      </li>
                      <li>
                        Once verified, a confirmation message will indicate that
                        your account is successfully backed up.
                      </li>
                      <li>
                        Tap <strong>Finish</strong> to return to the{" "}
                        <strong>Profile</strong> screen, where you’ll see that
                        backup status is marked as <strong>Backed up!</strong>
                      </li>
                    </ol>
                    <p className="accpara">
                      Now, when you want to log into your account on a different
                      device, you could choose the option{" "}
                      <strong>Already have an account</strong> on the opening
                      screen and import your account along with all the profiles
                      associated with it by entering your seed phrase.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="invitefriends">
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Invite Friends</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      To invite friends and start connecting on the tomi app,
                      perform the following steps:
                    </p>
                    <ol>
                      <li>
                        On the app home screen, tap{" "}
                        <strong>Invite friends</strong> in the
                        <strong>Friends</strong> section.
                      </li>
                      <li>
                        In the <strong>Find a Friend</strong> screen, you can:
                      </li>
                      <ul>
                        <li>
                          <strong>Search for friends already on tomi</strong>:
                          Use the search bar at the top to type in their
                          username or handle.
                        </li>
                        <li>
                          <strong>Create a group </strong> (upcoming feature):
                          If you'd like to start a group chat instead of
                          inviting individuals, tap Create Group.
                        </li>
                        <li>
                          <strong>Copy your invitation link</strong>: Tap this
                          option to generate and copy your unique invite link.
                          You can then share it via text, email, or social media
                          to invite others who aren’t yet on tomi.
                        </li>
                      </ul>
                      <li>
                        If your friend is already using tomi, their profile will
                        appear in the search results. Tap their profile to open
                        a chat window.
                      </li>
                      <li>
                        Type your message in the text box at the bottom and hit
                        the send icon to start chatting.
                      </li>
                    </ol>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="addcryptotoyourwallet">
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Add Crypto to Your Wallet</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      To add crypto to your wallet in the tomi app, perform the
                      following steps:
                    </p>
                    <ol>
                      <li>
                        On the app home screen, tap the Wallet button at the
                        bottom of the screen.
                      </li>
                      <li>
                        If this is the first time you’re using the wallet,
                        you’ll see the{" "}
                        <strong>Welcome to your tomi Wallet!</strong> screen.
                      </li>
                      <li>
                        Tap <strong>Add Crypto.</strong>
                      </li>
                      <li>
                        Select the blockchain you want to use from the list of
                        supported blockchains (e.g., Ethereum, Solana, BSC,
                        Bitcoin, Tron, Polygon).
                      </li>
                      <li>
                        Your unique wallet address will be displayed along with
                        a QR code. You can:
                      </li>
                      <ul>
                        <li>
                          Scan the QR code using another wallet or exchange app
                          to transfer funds.
                        </li>
                        <li>
                          Use your external wallet or exchange to send funds to
                          the copied address or QR code. Ensure that you send
                          funds on the same blockchain you selected in Step 3.
                        </li>
                      </ul>
                      <li>
                        Use your external wallet or exchange to send funds to
                        the copied address or QR code. Ensure that you send
                        funds on the same blockchain you selected in Step 3.
                      </li>
                      <li>
                        Once the transaction is complete, return to your tomi
                        Wallet. Your balance will update automatically, showing
                        the added crypto and a breakdown of holdings by token
                        and blockchain.
                      </li>
                    </ol>
                    <p className="accpara">
                      <strong>Note:</strong> Users can have multiple profiles,
                      but all of them share the same balance.
                    </p>
                    <p className="accpara">
                      <strong>Important:</strong>
                    </p>
                    <ul>
                      <li>
                        Network fees may apply for each transaction (e.g., gas
                        fees). Ensure you have enough funds in your external
                        wallet to cover these fees.
                      </li>
                      <li>
                        Double-check all details before confirming a transaction
                        to avoid errors.
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="edityourprofile">
                <Accordion.Item eventKey="4">
                  <Accordion.Header>Edit your profile</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">To edit your profile:</p>
                    <ol>
                      <li>
                        On the app home screen, tap your profile picture or
                        avatar in the top-left corner to access the{" "}
                        <strong>Profile</strong> screen.
                      </li>
                      <li>
                        Tap <strong>Change profile picture</strong> under your
                        current avatar.
                      </li>
                      <li>Select one of the following options:</li>
                      <ul>
                        <li>Choose an avatar from the available options.</li>
                        <li>
                          Tap the plus (+) icon to upload an image from your
                          device or take a photo.
                        </li>
                      </ul>
                      <li>will be updated immediately.</li>
                    </ol>
                    <p className="accpara">
                      <strong>Note:</strong> Future updates will include
                      additional profile editing settings, such as the ability
                      to make your profile private or public.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="addinganewprofile">
                <Accordion.Item eventKey="5">
                  <Accordion.Header>Adding a new profile</Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      The tomi app supports multiple profiles, allowing you to
                      separate personal and professional identities. To add a
                      new profile, follow these steps:
                    </p>
                    <ol>
                      <li>
                        On the app home screen, tap your profile picture or
                        avatar in the top-left corner to access the{" "}
                        <strong>Profile</strong>
                        screen.
                      </li>
                      <li>
                        On the <strong>Profile</strong> screen, tap{" "}
                        <strong>Add Profile</strong>.
                      </li>
                      <li>
                        Tap <strong>Let’s get started</strong> on the welcome
                        screen to continue.
                      </li>
                      <li>
                        On the <strong>Add a Username</strong> screen:
                      </li>
                      <ul>
                        <li>
                          Enter the username you’d like to use for this new
                          profile.
                        </li>
                        <li>
                          Slide right on the slider bar at the bottom to claim
                          your username.
                        </li>
                      </ul>
                      <li>
                        If the username is available, a confirmation message
                        will appear, and your new profile will be created.
                      </li>
                      <li>
                        Customize your new profile by setting a profile picture
                        and other details as needed.
                      </li>
                    </ol>
                    <p className="accpara">
                      <strong>Note:</strong> Currently, all the profiles in the
                      account share the same wallet address. This means that the
                      wallet is linked to the account itself, rather than to
                      each individual profile.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
              <Element name="importanexistingaccount">
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    Import an existing account
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="accpara">
                      If you already have a tomi account, you can easily import
                      it using your secret recovery phrase. This process allows
                      you to restore access to your account and profiles
                      securely. Follow these steps to import your account:
                    </p>
                    <ol>
                      <li>
                        On the app's opening screen, tap{" "}
                        <strong>Already have an account</strong>.
                      </li>
                      <li>
                        On the <strong>Recover Your Account</strong> screen,
                        enter your 12-word secret recovery phrase in the fields
                        provided. Make sure to input each word in the correct
                        order.
                      </li>
                      <li>
                        Once all 12 words are entered, tap{" "}
                        <strong>Continue</strong>.
                      </li>
                      <li>
                        If the recovery phrase is correct, the app will restore
                        your account and display a welcome screen showing all
                        profiles associated with the account.
                      </li>
                      <li>
                        Select the profile you want to use by tapping on it.
                        You’ll be redirected to the app’s home screen, where you
                        can start using your account.
                      </li>
                    </ol>
                    <p className="accpara">
                      <strong>Important:</strong>
                    </p>
                    <ul>
                      <li>
                        Keep your recovery phrase private and secure. Anyone
                        with access to it can control your account.
                      </li>
                      <li>
                        If you encounter issues during recovery, double-check
                        the spelling and order of the words in your recovery
                        phrase.
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Element>
            </Accordion>
          </div>
          <div className="bottom-btns">
            {/* <NavLink
              exact
              to="/support/ourfeatures"
              className="innerbtn firstbtn"
            >
              <div className="leftbtn">
                <p className="innerbtnpara">Overview - Previous</p>
                <p className="innerbtnhead">Our Features</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink> */}
            <NavLink exact to="/support/chatandpayments" className="innerbtn">
              <div className="leftbtn">
                <p className="innerbtnpara">Next</p>
                <p className="innerbtnhead">Chat and Payments</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink>
          </div>
        </div>
        <div className="right-sidebar">
          <div className="main-heading">
            <span>On this page</span>
          </div>
          <div className="rightlinks">
            <Link
              to="createanewtomiaccount"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Create a new tomi account
            </Link>
            <Link
              to="backupyourseedphrase"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Backup your seed phrase
            </Link>
            <Link
              to="invitefriends"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Invite Friends
            </Link>
            <Link
              to="addcryptotoyourwallet"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Add Crypto to Your Wallet
            </Link>
            <Link
              to="edityourprofile"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Edit your profile
            </Link>
            <Link
              to="addinganewprofile"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Adding a new profile
            </Link>
            <Link
              to="importanexistingaccount"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              Import an existing account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gettingstarted;
